
import Component from "./Routes";

export default (Component);
